// extracted by mini-css-extract-plugin
export var asset = "RichTextAsset-module--asset--92d51";